import { animate, state, style, transition, trigger } from '@angular/animations';
import { NgClass, NgIf } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { Router, RouterLink } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { LanguageSignalService } from 'src/app/core/services/language.service';
import { AuthService } from 'src/app/modules/auth/services/auth.service';
import { MatButtonModule } from '@angular/material/button';
import { environment } from 'src/environments/environment';
import { EmployeeModel } from 'src/app/modules/admin/pages/user/models/user-model';
import { ClickOutsideDirective } from 'src/app/shared/directives/click-outside.directive';
import { ThemeService } from 'src/app/core/services/theme.service';

@Component({
  selector: 'app-profile-menu',
  templateUrl: './profile-menu.component.html',
  styleUrls: ['./profile-menu.component.scss'],
  standalone: true,
  imports: [
    ClickOutsideDirective,
    NgClass,
    RouterLink,
    AngularSvgIconModule,
    NgIf,
    MatButtonModule,
    MatIconModule,
    TranslateModule,
  ],
  animations: [
    trigger('openClose', [
      state(
        'open',
        style({
          opacity: 1,
          transform: 'translateY(0)',
          visibility: 'visible',
        }),
      ),
      state(
        'closed',
        style({
          opacity: 0,
          transform: 'translateY(-20px)',
          visibility: 'hidden',
        }),
      ),
      transition('open => closed', [animate('0.2s')]),
      transition('closed => open', [animate('0.2s')]),
    ]),
  ],
})
export class ProfileMenuComponent implements OnInit {
  public isOpen = false;
  public profileMenu = [
    {
      title: 'Your Profile',
      icon: './assets/icons/user-circle.svg',
      link: '/profile',
      hidden: true,
      action: '',
    },
    {
      title: 'Settings',
      icon: './assets/icons/cog-6-tooth.svg',
      link: '/settings',
      hidden: true,
      action: '',
    },
    {
      title: 'COMMON.LOGOUT',
      icon: './assets/icons/logout.svg',
      link: '/auth/sign-in',
      hidden: false,
      action: 'logout',
    },
  ];

  public themeColors = [
    {
      name: 'base',
      code: '#e11d48',
    },
    {
      name: 'yellow',
      code: '#f59e0b',
    },
    {
      name: 'green',
      code: '#22c55e',
    },
    {
      name: 'blue',
      code: '#3b82f6',
    },
    {
      name: 'orange',
      code: '#ea580c',
    },
    {
      name: 'red',
      code: '#cc0022',
    },
    {
      name: 'violet',
      code: '#6d28d9',
    },
  ];

  public themeMode = ['light', 'dark'];

  public languages = [
    { id: 'en', name: 'English' },
    { id: 'no', name: ' Norsk' },
  ];

  selectedLanguage = '';

  apps = [
    {
      name: 'Workplace Safety',
      link: '',
      icon: 'science',
    },
    {
      name: 'Chem Request',
      link: '',
      icon: 'drag_indicator',
    },
  ];

  userLoginInfo: EmployeeModel = new EmployeeModel();

  constructor(
    public themeService: ThemeService,
    private _router: Router,
    private authService: AuthService,
    private translateService: TranslateService,
    public languageService: LanguageSignalService,
    private adminService: AuthService,
  ) {}

  ngOnInit(): void {
    const lang = localStorage.getItem('languageCulture') || 'en';
    this.selectedLanguage = lang;

    this.apps = this.apps.map((app) => {
      const item = {
        ...app,
        link: (app.name === 'Workplace Safety' ? environment.workplaceSafety : environment.chemReq) || '',
      };
      return item;
    });

    this.adminService.getUserProfile().subscribe((res) => {
      if (res) {
        this.userLoginInfo = res;
      }
    });
  }

  public toggleMenu(): void {
    this.isOpen = !this.isOpen;
  }

  onClickedOutside() {
    if(this.isOpen) {
      this.isOpen = false;
    }
  }

  toggleThemeMode() {
    this.themeService.theme.update((theme) => {
      const mode = !this.themeService.isDark ? 'dark' : 'light';
      return { ...theme, mode: mode };
    });
  }

  toggleThemeColor(color: string) {
    this.themeService.theme.update((theme) => {
      return { ...theme, color: color };
    });
  }

  onClickMenuItem(item: any) {
    switch (item.action) {
      case 'logout':
        this.authService.logout();
        // this._router.navigate([`${item.link}`]);
        break;

      default:
        console.log(item.title);
        break;
    }
    this.toggleMenu();
  }

  changeLanguage(item: any) {
    this.selectedLanguage = item.id;
    this.translateService.use(this.selectedLanguage);
    localStorage.setItem('languageCulture', this.selectedLanguage);

    this.languageService.setLanguage(this.selectedLanguage as 'en' | 'no');

    this.toggleMenu();
  }
}
